import React from 'react';
import { Box, Switch, Typography } from '@material-ui/core';
import { Field } from 'react-final-form';

/**
 * Añade aquí nuevos toggles; se guardan con el Save del cohort vía `cohort_settings` en el formulario.
 * @typedef {{ apiKey: string, label: string, responseKeys?: string[] }} CohortBooleanSettingField
 */

/** @type {CohortBooleanSettingField[]} */
export const DEFAULT_COHORT_BOOLEAN_SETTINGS = [
  {
    apiKey: 'multilanguageEnabled',
    responseKeys: ['multilanguage_enabled'],
    label: 'Multilanguage active',
  },
];

function getBooleanFromRecord(record, field) {
  if (!record) {
    return false;
  }
  const keys = [field.apiKey, ...(field.responseKeys || [])];
  for (const k of keys) {
    if (record[k] !== undefined && record[k] !== null) {
      return Boolean(record[k]);
    }
  }
  return false;
}

/**
 * Valores iniciales del fragmento `cohort_settings` del formulario (GET /cohorts/:id/settings).
 * @param {object | undefined} apiData
 * @param {CohortBooleanSettingField[]} [fields]
 */
export function cohortSettingsToFormValue(
  apiData,
  fields = DEFAULT_COHORT_BOOLEAN_SETTINGS,
) {
  const base = apiData && typeof apiData === 'object' ? { ...apiData } : {};
  delete base.id;
  delete base._id;
  const out = { ...base };
  fields.forEach((field) => {
    out[field.apiKey] = getBooleanFromRecord(out, field);
  });
  return out;
}

/**
 * Campos enlazados a `cohort_settings.*` (react-final-form). Los datos vienen de `initialValues`.
 * @param {{ cohortId?: string, fields?: CohortBooleanSettingField[] }} props
 */
const CohortSettingsInput = ({
  cohortId,
  fields = DEFAULT_COHORT_BOOLEAN_SETTINGS,
}) => {
  if (!cohortId) {
    return (
      <Typography variant="body2" color="textSecondary">
        Save the cohort first to edit settings.
      </Typography>
    );
  }

  return (
    <Box display="flex" flexDirection="column">
      {fields.map((field) => (
        <Box
          key={field.apiKey}
          display="inline-flex"
          alignItems="center"
          mb={0.5}
        >
          <Field name={`cohort_settings.${field.apiKey}`} type="checkbox">
            {({ input }) => (
              <Switch
                checked={Boolean(input.checked)}
                onChange={(_event, checked) => input.onChange(checked)}
                color="primary"
              />
            )}
          </Field>
          <Typography variant="body2">{field.label}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CohortSettingsInput;
